///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum GtthSectorObstruction {
    LEFT,
    RIGHT
}
